/**
 * Canonical currency constants.
 * Single source of truth — replaces duplicated Sets/maps across the codebase.
 */

export const FIAT_CURRENCIES = new Set([
  'EUR', 'USD', 'GBP', 'CHF', 'PLN', 'SEK', 'AED', 'ARS', 'CZK', 'DKK',
  'NOK', 'HUF', 'RON', 'BGN', 'HRK', 'TRY', 'BRL', 'MXN', 'JPY', 'CNY',
  'INR', 'KRW', 'CAD', 'AUD', 'NZD', 'ZAR', 'SGD', 'HKD', 'THB', 'MYR',
  'PHP', 'IDR', 'TWD', 'ILS', 'CLP', 'COP', 'PEN', 'RUB', 'KZT', 'UAH',
  'ISK', 'SAR',
])

export const CURRENCY_SYMBOLS: Record<string, string> = {
  EUR: '€', USD: '$', GBP: '£', CHF: 'CHF', JPY: '¥', CNY: '¥',
  INR: '₹', KRW: '₩', TRY: '₺', RUB: '₽', PLN: 'zł', BRL: 'R$',
  ILS: '₪', THB: '฿', SEK: 'kr', AED: 'AED', ARS: '$',
}

export const CURRENCY_TO_COUNTRY: Record<string, string> = {
  EUR: 'eu', USD: 'us', GBP: 'gb', CHF: 'ch', ARS: 'ar', BRL: 'br',
  CNY: 'cn', JPY: 'jp', RUB: 'ru', KZT: 'kz', INR: 'in', AUD: 'au',
  CAD: 'ca', PLN: 'pl', SEK: 'se', NOK: 'no', DKK: 'dk', CZK: 'cz',
  HUF: 'hu', TRY: 'tr', ZAR: 'za', MXN: 'mx', SGD: 'sg', HKD: 'hk',
  NZD: 'nz', KRW: 'kr', ILS: 'il', AED: 'ae', SAR: 'sa', THB: 'th',
  BGN: 'bg', UAH: 'ua', RON: 'ro', HRK: 'hr', ISK: 'is',
}
